export default {
  props: {
    modelValue: File,
    label: String,
    accept: String,
    errors: {
      type: Array,
      "default": function _default() {
        return [];
      }
    }
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue: function modelValue(value) {
      if (!value) {
        this.$refs.file.value = '';
      }
    }
  },
  methods: {
    filesize: function filesize(size) {
      var i = Math.floor(Math.log(size) / Math.log(1024));
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
    },
    browse: function browse() {
      this.$refs.file.click();
    },
    change: function change(e) {
      this.$emit('update:modelValue', e.target.files[0]);
    },
    remove: function remove() {
      this.$emit('update:modelValue', null);
    }
  }
};